// @flow

import * as logos from './logos';

export function getCustomThemeLogo(id: string): string {
  return logos[id];
}
